// extracted by mini-css-extract-plugin
module.exports = {"cornerContainer":"CornerFooter_cornerContainer__1Mr9G","greyCorner":"CornerFooter_greyCorner__2oINv"};